import { render } from "./SelectionMenuStep4.vue?vue&type=template&id=59a1d3a4&scoped=true"
import script from "./SelectionMenuStep4.vue?vue&type=script&lang=ts"
export * from "./SelectionMenuStep4.vue?vue&type=script&lang=ts"

import "./SelectionMenuStep4.vue?vue&type=style&index=0&id=59a1d3a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59a1d3a4"

export default script